<template>
  <div class="brand-header">
    <img
      class="circular-logo"
      :src="logo"
      :alt="name + ' logo'"
    >
    <p>{{ name || 'Unknown brand' }} ></p>
  </div>
</template>

<script>
import productImage from '@/assets/images/elements/default-product.jpeg'

export default {
  name: 'BrandHeader',
  props: {
    name: {
      type: String,
      default: 'Unknown brand',
    },
    logo: {
      type: String,
      default() {
        return productImage
      },
    },
  },
}
</script>

<style scoped lang="scss">
.brand-header {
  border-bottom: 1px solid #292929;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 0;
  margin-bottom: 16px;

  .circular-logo {
    width: 69px;
    height: 69px;
    border-radius: 50%;
    object-fit: contain;
  }

  p {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 0;
  }
}
</style>
